import script from "./cookiePop.vue?vue&type=script&setup=true&name=cookiePop&lang=js"
export * from "./cookiePop.vue?vue&type=script&setup=true&name=cookiePop&lang=js"

const __exports__ = script;

export default __exports__